import React from 'react'
import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl'

import messages from './messages'

import {
    STATUS_UNAVAILABLE,
    STATUS_UNAVAILABLE_RATES,
    STATUS_UNAVAILABLE_PARKING_IS_FULL,
    STATUS_UNAVAILABLE_PARKING_IS_CLOSED,
    STATUS_UNAVAILABLE_BOOKING_ADVANCE_TIME_REACHED,
    STATUS_UNAVAILABLE_BOOKING_MAX_STAY_TIME_REACHED,
    STATUS_UNAVAILABLE_BOOKING_MIN_STAY_NOT_REACHED,
} from 'commons/js/constants'

import {
    formatMinuteDuration,
} from 'commons/js/util/dateConverter'

const errorMap = {
    [STATUS_UNAVAILABLE]: messages.unavailable,
    [STATUS_UNAVAILABLE_RATES]: messages.unavailableRates,
    [STATUS_UNAVAILABLE_PARKING_IS_FULL]: messages.unavailableParkingFull,
    [STATUS_UNAVAILABLE_PARKING_IS_CLOSED]: messages.unavailableParkingClosed,
    [STATUS_UNAVAILABLE_BOOKING_ADVANCE_TIME_REACHED]: messages.unavailableBookingAdvanceTimeReached,
    [STATUS_UNAVAILABLE_BOOKING_MAX_STAY_TIME_REACHED]: messages.unavailableBookingMaxStayTimeReached,
    [STATUS_UNAVAILABLE_BOOKING_MIN_STAY_NOT_REACHED]: messages.unavailableBookingMinStayNotReached,
}

const getErrorMessage = (error) => errorMap[error.status]

const getErrorValues = (error) => {
    switch (error.status) {
        case STATUS_UNAVAILABLE_BOOKING_ADVANCE_TIME_REACHED:
        case STATUS_UNAVAILABLE_BOOKING_MAX_STAY_TIME_REACHED:
        case STATUS_UNAVAILABLE_BOOKING_MIN_STAY_NOT_REACHED:
            return {
                duration: formatMinuteDuration(error.data.minutes),
            }
        default:
            return error.data
    }
}

const AvailabilityErrorMessage = ({ error }) => {
    const message = getErrorMessage(error)

    if (!message) {
        return <FormattedMessage {...messages.unknown} />
    }

    return <FormattedMessage {...message} values={{...getErrorValues(error)}} />
}

AvailabilityErrorMessage.propTypes = {
    error: PropTypes.shape({
        status: PropTypes.string,
        data: PropTypes.object,
    }),
}

export default AvailabilityErrorMessage
